import { and, clone, cond, has, prop } from 'ramda';
import { isArray, isObject, isString } from "ramda-adjunct";

const remoteAsString = (str: string) =>clone(({type: 'REMOTE' as any, url: str, key: str}))
const remoteAsObject = (obj:any) =>clone(({key:obj.url,...obj,type: 'REMOTE'}))

const memoryAsArray = (arr:any) => clone(({type: 'MEMORY', elements: arr, key: "in-memory" + arr.length}))

const memoryAsDefault = (arr?:any) => clone(({type: 'MEMORY', elements: arr, key: "in-memory-default" }))

export const getTableSource = (target: any) => {
  const source = prop("source",target);
  const result = cond([
    [isString, remoteAsString],
    [and(isObject,has("url")), remoteAsObject],
    [isArray, memoryAsArray],
    [() => true, (el?:any)=>(memoryAsDefault(el !== undefined ? [el] : []))]
  ])(source);
  return result;
}
